import React from "react";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import SelectField from "../../components/form/SelectField";
import InputField from "../../components/form/InputField";
import AddResource from "../../components/header/AddResource";
import { getCountries } from "../../features/countriesSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNotification } from "../../components/notification/NotificationContainer";
import { addNation, editNation } from "../../features/nationsSlice";
import PhoneInputField from "../../components/form/PhoneInputField";
import { useForm } from "react-hook-form";
import { closeModal } from "../../features/modalSLice";
import { useEffect } from "react";
import loadStatus from "../../util/loadStatus";
import Loading from "../../components/loading/Loading";
import { addNationSchema } from "../../schemas";
import { zodResolver } from "@hookform/resolvers/zod";

const AddNation = ({ edit, id }) => {
  const dispatch = useDispatch();
  const addNotification = useNotification();
  const countries = useSelector((state) => state.countries.data);
  const nation = useSelector((state) => state.nations.selected);
  const nationLoad = useSelector((state) => state.nations.load.getNation);
  const addNationLoad = useSelector((state) => state.nations.load.addNation);
  const editNationLoad = useSelector((state) => state.nations.load.editNation);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(addNationSchema),
    defaultValues: { name: "" },
  });

  const onSubmit = async (data, e) => {
    e.preventDefault();
    try {
      if (edit) {
        const res = await dispatch(editNation({ id, data: data }));
        if (editNation.fulfilled.match(res)) {
          dispatch(closeModal());
          addNotification("Nation Updated Successfully!", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      } else {
        const res = await dispatch(addNation(data));
        if (addNation.fulfilled.match(res)) {
          dispatch(closeModal());
          addNotification("Nation Added Successfully!", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  useEffect(() => {
    dispatch(getCountries());
  }, []);

  useEffect(() => {
    if (nation.id && edit) {
      reset({
        country_id: nation.country_id,
        name: nation.name,
        type: nation.type,
        email: nation.email,
        address1: nation.address1,
        address2: nation.address2,
        phone: nation.phone,
        phone2: nation.phone2,
      });
    }
  }, [nation, countries]);

  if (nationLoad === loadStatus.loading && edit) {
    return (
      <div className="min-w-72 sm:min-w-96 lg:min-w-96 w-full h-96">
        <Loading />
      </div>
    );
  }

  return (
    <div className="min-w-72 sm:min-w-[26rem] lg:min-w-96">
      <AddResource title={edit ? "Edit Country" : "Add Country"} />
      <form
        autoCorrect="off"
        autoComplete="off"
        aut
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex flex-col justify-center items-center gap-2 w-full">
          <InputField
            register={register}
            type="text"
            autoComplete="off"
            label="Name"
            name="name"
            errors={errors.name}
          />
          <InputField
            register={register}
            type="email"
            autoComplete="off"
            label="Email"
            name="email"
            errors={errors.email}
          />
          <InputField
            register={register}
            type="text"
            autoComplete="off"
            label="Address 1"
            name="address1"
            errors={errors.address1}
          />
          <InputField
            register={register}
            type="text"
            autoComplete="off"
            label="Address 2"
            name="address2"
            errors={errors.address2}
          />
          <SelectField
            data={[{ id: "", name: "-- Select Country" }, ...countries]}
            register={register}
            label="Country"
            name="country_id"
            errors={errors.country_id}
          />
          <SelectField
            data={[
              { id: "", name: "-- Select Type" },
              { id: "main", name: "Main" },
              { id: "antenna", name: "Antenna" },
            ]}
            register={register}
            label="Type"
            name="type"
            errors={errors.type}
          />
          <PhoneInputField
            register={register}
            name="phone"
            label="Mobile"
            errors={errors.phone}
            setValue={setValue}
            defaultValue={nation.phone || ""}
          />
          <PhoneInputField
            register={register}
            name="phone2"
            label="Phone"
            errors={errors.phone2}
            setValue={setValue}
            defaultValue={nation.phone2 || ""}
          />
        </div>
        {/* <div className="flex items-center justify-end py-6">
          <button className="add-rss-btn" type="submit">
            Submit
          </button>
        </div> */}
        <ResourseButtons loading={addNationLoad || editNationLoad} />
      </form>
    </div>
  );
};

export default AddNation;
